import { ROUTE_NAME_WEB } from "@/router/webRoutes";
import { ROUTE_NAME } from "@/router";
import { Capacitor } from "@capacitor/core";

import { APP_ENVIROMENT } from "@/types/enum/general";
import { usePersistentStore } from "@/stores/persistent";

export let forceAppVersion = localStorage.getItem('forceAppVersion') === 'true'

export const setForceAppVersion = (newValue: boolean) => {
    forceAppVersion = newValue
    localStorage.setItem('forceAppVersion', newValue.toString())
}

export const routeEnvironment = (webRoute: ROUTE_NAME_WEB, appRoute: ROUTE_NAME): ROUTE_NAME_WEB | ROUTE_NAME => {
    return isApp() ? appRoute : webRoute
}

export const isApp = (): boolean => {
    if (Capacitor.isNativePlatform()) return true
    if (forceAppVersion) return true
    return process.env.VUE_APP_DEVELOPMENT_ENV === APP_ENVIROMENT.APP
}

export const isNotLive = (): boolean => {
    const persistentStore = usePersistentStore()
    return persistentStore.apiUrl !== process.env.VUE_APP_ROOT_API
}

export const isDev = (): boolean => {
    const persistentStore = usePersistentStore()
    if (!isNotLive()) return false
    return !persistentStore.apiUrl.includes('dev')
}

export const appResult = isApp()

export const isNativeApp = Capacitor.isNativePlatform();